export default __webpack_public_path__ + "swiper-shadow-rightc32475.png";